module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/slideBtn.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/slideBtn.png
// module id = 1309
// module chunks = 438